<template>
  <section>
    <b-field grouped group-multiline>
      <b-field>
        <b-select
          v-model="selectedArea"
          :loading="loadingAreas"
          :placeholder="$t('message.please_select') + $t('attributes.area')"
          @input="onFilter"
        >
          <option value="" disabled>
            {{ $t('message.please_select') + $t('attributes.area') }}
          </option>
          <option v-for="option in areas" :value="option" :key="option.code">
            {{ option.name }}
          </option>
        </b-select>
      </b-field>
      <b-field>
        <p class="control">
          <span class="button is-static">
            {{
              $t('attributes.blog_share') +
                $t('attributes.join') +
                $t('attributes.activation_status')
            }}
          </span>
        </p>
        <b-select v-model="filterStatus" @input="onFilter">
          <option value="Y">{{ $t('attributes.joined') }}</option>
          <option value="N">{{ $t('attributes.not_join') }}</option>
        </b-select>
      </b-field>
    </b-field>
    <b-table
      :data="blogs"
      :loading="loadingBlogs"
      :hoverable="true"
      :narrowed="true"
      :mobile-cards="true"
      paginated
      backend-pagination
      backend-sorting
      :total="total"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <b-table-column
        :label="$t('attributes.function')"
        width="250"
        centered
        v-slot="props"
      >
        <b-button type="is-info" @click.prevent.stop="onModify(props.row)">
          {{
            props.row.honeymoon
              ? $t('attributes.cancel') + $t('attributes.join')
              : $t('attributes.join')
          }}
        </b-button>
      </b-table-column>
      <b-table-column
        :label="$t('attributes.picture')"
        width="120"
        centered
        v-slot="props"
      >
        <a
          v-if="props.row.image"
          :href="BlogShareImage(props.row.image)"
          @click.prevent="onClickImage(props.row.image)"
        >
          <figure class="image">
            <img
              :src="BlogShareImage(props.row.image)"
              :alt="$t('attributes.picture')"
              style="width: 120px; margin: auto;"
            />
          </figure>
        </a>
      </b-table-column>
      <b-table-column
        field="topic"
        :label="$t('attributes.name')"
        centered
        v-slot="props"
      >
        {{ props.row.topic }}
      </b-table-column>
      <b-table-column
        field="create_date"
        :label="$t('attributes.create_date')"
        sortable
        centered
        v-slot="props"
      >
        {{
          props.row.create_date.split('T')[0] +
            ' ' +
            props.row.create_date.split('T')[1]
        }}
      </b-table-column>
      <b-table-column
        field="status"
        :label="$t('attributes.blog_share') + $t('attributes.status')"
        sortable
        centered
        v-slot="props"
      >
        {{
          props.row.status
            ? $t('attributes.shelve_on')
            : $t('attributes.shelve_off')
        }}
      </b-table-column>
    </b-table>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import debounce from 'lodash/debounce'
import { AREA_API, HONEY_MOON_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'HoneyMoonBlogList',
  data() {
    return {
      areas: [],
      selectedArea: null,
      loadingAreas: false,

      filterStatus: 'Y',

      loadingBlogs: false,
      blogs: [],
      selectedBlog: null,
      total: 0,
      sortField: 'sort',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',
      page: 1,
      perPage: 15,

      isImageModalActive: false,
      selectedImageUrl: ''
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      await this.loadAreas()
      await this.loadBlogShares()
    },
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        this.areas = res.data.data.sort(a => a.sort)
        this.selectedArea = null
      } catch (e) {
        this.areas = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    async loadBlogShares() {
      const api = `${HONEY_MOON_API}/list/blog-shares`
      this.loadingBlogs = true
      try {
        const params = {
          code: this.selectedArea && this.selectedArea.code,
          honeyMoon: this.filterStatus,
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }
        const res = await this.axios.get(api, { params })
        this.blogs = res.data.data.items
        this.total = res.data.data.item_count
      } catch (e) {
        this.blogs = []
        this.total = 0
        notifyService.fetch_error('blog_share', e)
      } finally {
        this.loadingBlogs = false
      }
    },
    onPageChange(page) {
      this.page = page
      this.loadBlogShares()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.loadBlogShares()
    },
    onModify(item) {
      this.selectedBlog = item
      this.updateJoinHoneyMoon()
    },
    async updateJoinHoneyMoon() {
      const api = `${HONEY_MOON_API}/update/blog-shares`

      try {
        this.loadingBlogs = true
        this.filterStatus = this.selectedBlog.honeymoon ? 'N' : 'Y'
        const params = {
          honey_moon: this.selectedBlog.honeymoon ? 'N' : 'Y',
          blog_share_id: this.selectedBlog.id
        }
        await this.axios.put(api, params)

        notifyService.success(this.$t('attributes.update_succeed'))

        await this.loadBlogShares()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.loadingBlogs = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = this.BlogShareImage(url)
    },
    onFilter: debounce(function() {
      this.loadBlogShares()
    }, 500)
  }
}
</script>
